// Copyright (c) 2026 Watch Tower Bible and Tract Society of Pennsylvania
// All Rights Reserved. Proprietary and confidential.
// Unauthorized copying, modification, or distribution is strictly prohibited.
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from '../ui/dialog';
import { Button } from '../ui/button';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '../ui/select';
import { Label } from '../ui/label';
import { Plus, Loader2 } from 'lucide-react';

const TRIMESTERS = ['1º Trimestre', '2º Trimestre', '3º Trimestre', '4º Trimestre'];
export const TRIMESTER_MONTHS = {
  '1º Trimestre': ['Setembro', 'Outubro', 'Novembro'],
  '2º Trimestre': ['Dezembro', 'Janeiro', 'Fevereiro'],
  '3º Trimestre': ['Março', 'Abril', 'Maio'],
  '4º Trimestre': ['Junho', 'Julho', 'Agosto'],
};

export default function NewAuditFormDialog({
  open,
  onOpenChange,
  formLabel,
  formConfig,
  years,
  selectedYear,
  setSelectedYear,
  selectedTrimester,
  setSelectedTrimester,
  monthly = false,
  selectedMonth,
  setSelectedMonth,
  creating,
  onCreate,
}) {
  const monthOptions = TRIMESTER_MONTHS[selectedTrimester] || [];
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md" data-testid="new-form-dialog">
        <DialogHeader>
          <DialogTitle>Novo Relatório {formLabel}</DialogTitle>
          <DialogDescription>
            Selecione o ano{monthly ? ', o trimestre e o mês' : ' e o trimestre'} da auditoria ({formConfig.fullTitle})
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-4 py-4">
          <div className="space-y-1.5">
            <Label className="text-sm font-medium text-foreground">Ano</Label>
            <Select value={selectedYear} onValueChange={setSelectedYear}>
              <SelectTrigger data-testid="select-year-form">
                <SelectValue placeholder="Selecione o ano..." />
              </SelectTrigger>
              <SelectContent>
                {years.map(y => {
                  const label = y.name.replace(/_/g, ' ');
                  return (
                    <SelectItem key={y.id} value={label}>
                      {label}
                    </SelectItem>
                  );
                })}
              </SelectContent>
            </Select>
          </div>
          <div className="space-y-1.5">
            <Label className="text-sm font-medium text-foreground">Trimestre</Label>
            <Select
              value={selectedTrimester}
              onValueChange={(v) => { setSelectedTrimester(v); if (monthly) setSelectedMonth(''); }}
            >
              <SelectTrigger data-testid="select-trimester-form">
                <SelectValue placeholder="Selecione o trimestre..." />
              </SelectTrigger>
              <SelectContent>
                {TRIMESTERS.map(t => (
                  <SelectItem key={t} value={t}>{t}</SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
          {monthly && (
            <div className="space-y-1.5">
              <Label className="text-sm font-medium text-foreground">Mês</Label>
              <Select value={selectedMonth} onValueChange={setSelectedMonth} disabled={!selectedTrimester}>
                <SelectTrigger data-testid="select-month-form">
                  <SelectValue placeholder={selectedTrimester ? 'Selecione o mês...' : 'Escolha o trimestre primeiro'} />
                </SelectTrigger>
                <SelectContent>
                  {monthOptions.map(m => (
                    <SelectItem key={m} value={m}>{m}</SelectItem>
                  ))}
                </SelectContent>
              </Select>
            </div>
          )}
        </div>
        <div className="flex justify-end gap-3">
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            Cancelar
          </Button>
          <Button onClick={onCreate} disabled={creating} data-testid="create-form-btn">
            {creating ? (
              <Loader2 className="w-4 h-4 mr-2 animate-spin" />
            ) : (
              <Plus className="w-4 h-4 mr-2" />
            )}
            Criar
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
